import { createContext, useContext } from 'react';
import { PlanCardContextData as ContextData } from './types';

const context = createContext<ContextData>({} as ContextData);

export const { Provider } = context;

export const usePlanCardContext = () => useContext(context);
